import {SCAN_TYPE} from '@techsee/techsee-common/lib/constants/scan.constants';

export function isArScan(scan: any): boolean {
    return scan?.type === SCAN_TYPE.ar || scan?.scanDetails?.scanType === SCAN_TYPE.ar;
}

export function getAccessChannel(scan: any): any[] {
    return (
        scan?.channelAnalysis?.filter((val: {channel: any}) => val.channel === scan?.wifiConnectionInfo?.channel) ?? []
    );
}

export const IMAGE_TYPE = {
    BSSID_HEATMAP: 'bssid_heatmap',
    SSID_HEATMAP: 'ssid_heatmap'
};

export function getScanImageUrl(imageUrls: {type?: string; imageUrl?: string}[] | undefined): string {
    if (!imageUrls) {
        return '';
    }

    const ssidImage = imageUrls.find((img) => img.type === IMAGE_TYPE.SSID_HEATMAP);
    const targetImage = ssidImage || imageUrls.find((img) => img.type === IMAGE_TYPE.BSSID_HEATMAP);
    if (!targetImage?.imageUrl) {
        return '';
    }
    return targetImage.imageUrl;
}
